import { InstructionEmailForm } from '@/features/ap_payees/components/DocInstructionMenu/types';
import { Form } from '@moneyforward/ap-frontend-components';
import { TextAreaRef } from 'antd/es/input/TextArea';
import { RefObject } from 'react';
import { useFormContext } from 'react-hook-form';
import { InstructionContent } from '../Forms/InstructionContent';
import { InstructionSubject } from '../Forms/InstructionSubject';
import { InstructionTemplate } from '../Forms/InstructionTemplate';

interface InstructionInformationProps {
  textAreaRef: RefObject<TextAreaRef>;
}

export const InstructionInformation = ({
  textAreaRef,
}: InstructionInformationProps) => {
  const methods = useFormContext<InstructionEmailForm>();
  const { control } = methods;

  return (
    <Form<InstructionEmailForm>
      id='formInstructionInformation'
      testId='formInstructionInformation'
      formMethod={methods}
      onSubmit={() => {}}
    >
      <InstructionSubject control={control} />
      <InstructionContent control={control} textAreaRef={textAreaRef} />
      <InstructionTemplate control={control} />
    </Form>
  );
};

InstructionInformation.displayName = 'InstructionInformation';
